<template>
  <div v-if="!showDetail" style="height: 100%; display: flex; flex-direction: column;">
    <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search profit-share-config">
      <div class="section">
        <el-form
          label-position="left"
          label-width="85px"
        >
          <el-row style="margin-bottom: 5px;" :gutter="10">
            <el-col :span="24">
              <el-button type="primary" no="query" @click="toQuery"> {{ $t('CargoMsg.Cargo_Query') }} </el-button>
              <el-button type="primary" no="createRule" @click="toCreate"> {{ $t('CargoMsg.Cargo_CreateRule') }} </el-button>
              <el-button type="primary" no="editRule" @click="toEdit"> {{ $t('CargoMsg.Cargo_EditRule') }} </el-button>
              <el-button type="primary" no="copyRule" @click="toCopy"> {{ $t('CargoMsg.Cargo_CopyRule') }} </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="grid-view">
      <div class="main-content">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="261606"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="261606"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
  </div>
  <div v-else class="profit-share-config app-main-content" style="height: 100%">
    <div style="height: 28px; margin-left: 16px; margin-top: 16px">
      <el-button type="primary" @click="onSave()">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button type="default" @click="onCancel()">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'271px','min-width':'271px'}"
      style="min-height: 90%;border: 1px solid;margin: 16px;"
    >
      <template slot="left">
        <div class="tabs-container section">
          <!-- Right tabs -->
          <el-tabs v-model="activeTab" type="card" style="width: 100%" @tab-click="handleTabClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_RuleConfig')" name="activity">
              <el-form
                style="margin: 10px"
                label-position="top"
                label-width="200px"
              >
                <el-form-item :label="$t('CargoMsg.Cargo_RuleName')" required>
                  <el-input v-model="form.name" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_SalesBranchCompany')" required>
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Office"
                    multiple
                    clearable
                    filterable
                    :default-multiple-value="form.branchIds"
                    @parentCallBack="p=>{form.branchIds = p.value}"
                  />
                </el-form-item>
                <el-form-item style="height: 120px;" :label="$t('CargoMsg.Cargo_Remarks')">
                  <el-input v-model="form.remark" type="textarea" />
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('CargoMsg.Cargo_RuleRole')" name="node">
              <el-form
                :disabled="chooseIndex === null"
                style="margin: 10px;"
                label-position="top"
                label-width="200px"
                :class="chooseIndex === null ? 'no-click' : ''"
              >
                <el-form-item :label="$t('CargoMsg.Cargo_ShareMode')" required>
                  <el-select v-model="node.shareMode" no="shareMode" :clearable="false">
                    <el-option :label="$t('CargoMsg.Cargo_ShareModeJob')" value="job" />
                    <el-option :label="$t('CargoMsg.Cargo_ShareModeCurrency')" value="currency" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_UsdRatio')" required>
                  <el-input-number
                    v-model="node.usdRatio"
                    no="usdRatio"
                    :controls="false"
                    :min="0"
                    :max="100"
                    :precision="0"
                    style="width:230px;"
                  />%
                </el-form-item>
                <el-form-item v-if="showNonUsdRatioInput" :label="$t('CargoMsg.Cargo_NonUsdRatio')" required>
                  <el-input-number
                    v-model="node.nonUsdRatio"
                    no="nonUsdRatio"
                    :controls="false"
                    :min="0"
                    :max="100"
                    :precision="0"
                    style="width:230px;"
                  />%
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
      <template slot="right">
        <div style="width: 99%; height: 96%; overflow: auto; display: flex; flex-direction: column; background-color: white; margin: 12px 12px 12px 6px" class="col">
          <div style="width: 100%; height: 100%">
            <draggable v-model="form.subList" disabled animation="300" style="width: 100%;" @sort="sort">
              <transition-group style="width: 100%; ">
                <div v-for="(item, workflowIndex) in form.subList" :key="item.priority" class="item">
                  <div style="width: 100%; height: 100%">
                    <div style="height: 36px; background-color: rgba(244, 249, 255);display: flex">
                      <img src="/static/move.svg" style="align-self: center;margin-left:5px;width:11px;height:11px;">
                      <span style="align-self: center; margin-left: 5px">{{ $t('CargoMsg.Cargo_Priority') + (workflowIndex + 1) }}</span>
                      <span style="align-self: center; margin-left: 40px; color: rgba(65, 141, 220)" @click="onConfiguration(workflowIndex)">{{ $t('CargoMsg.Cargo_TriggerConditions') + ': ' + getTriggerConditionsLabel(item.ruleMode) }}</span>
                      <i style="align-self: center; color: red; margin-right: 10px" class="el-icon-delete" @click.capture="removeBranch(workflowIndex)" />
                    </div>
                    <draggable v-model="item.subRoleList" style="display: flex; flex-wrap: wrap; padding-left: 28px; margin-bottom: 15px;" :options="{handle:'.drag-handle'}" @end="toEnd">
                      <div v-for="(card, index) in item.subRoleList" :key="index" style="display: flex; flex-wrap: wrap; align-self: center; margin-top: 15px;">
                        <div
                          v-show="item.multiRole || (!item.multiRole && index < 1)"
                          :class="'record-card ' + (item.priority === choosePriority && index === chooseIndex ? 'is-active' : '') + (card.isAdd ? ' no-drag' : '')"
                          @click="chooseNode(card, item.priority, index)"
                        >
                          <div v-if="!card.isAdd">
                            <div style="margin: 10px; display: flex">
                              <div class="drag-handle" style="padding-right: 10px;">
                                <i class="el-icon-rank" style="margin-right: 10px;" />
                                <span class="node-name">{{ showShareMode(card) }}</span>
                              </div>
                              <i class="el-icon-delete" @click.capture="removeNode(workflowIndex, index)" />
                            </div>
                            <div :title="showUsdRatio(card)" class="card-content">
                              {{ showUsdRatio(card) }}
                            </div>
                            <div :title="showNonUsdRatio(card)" class="card-content" style="margin-top: 10px">
                              {{ showNonUsdRatio(card) }}
                            </div>
                          </div>
                          <div v-else>
                            <div style="height: 100%;margin-top: 10%;text-align: center; ">
                              <span style="cursor: pointer;font-size: 40px;color: rgba(159, 180, 225)" @click.stop="addNode(workflowIndex, item.priority)">+</span>
                            </div>
                          </div>
                        </div>
                        <div v-if="index < item.subRoleList.length - 1" style="position: relative;">
                          <div class="arrow-container" />
                        </div>
                      </div>
                    </draggable>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div>
              <el-button :disabled="!form.multiSub" type="text" style="background-color: rgba(244, 249, 255); margin-left: 10px;margin-top: 10px" @click="addBranchProcess">{{ $t('CargoMsg.Cargo_AddRuleConfigSub') }}</el-button>
            </div>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 触发条件配置 -->
    <rule-config-condition-dialog
      v-if="ruleConfigurationDialog.visible"
      :visible.sync="ruleConfigurationDialog.visible"
      :rules="rules"
      :workflow="form.subList[chooseWorkflowIndexRule]"
      @close="ruleConfigurationDialog.visible=false"
      @change="p => {form.subList[chooseWorkflowIndexRule] = p}"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import RuleConfigConditionDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/profitShareConfig/RuleConfigConditionDialog.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import * as commonUtil from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import { getLoading } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { query, detail, save, setEnabled, copy, queryConditions } from '@/api/sysManage/baseConfig/ruleConfig'
import lodash from 'lodash'

export default {
  name: 'ProfitShareConfig',
  components: { draggable, RuleConfigConditionDialog, CargoLeftRightResize, CargoAdvanceSelect },
  data() {
    return {
      checked: true,
      loading: false,
      // 不能使用process的index去确定选中的分支，因为索引会变化，处理起来复杂；所有使用process的固定值priority去确定选中的分支
      choosePriority: null,
      chooseIndex: null,
      chooseWorkflowIndexRule: null,
      form: {
        name: '',
        branchIds: [],
        remark: '',
        enabled: true,
        ruleType: 'profitShare', // 规则类型
        multiSub: true, // 是否多个分支
        subList: [{
          priority: 1,
          ruleMode: WorkflowConstants.RULE_CONDITIONS_ALL.code,
          multiRole: false,
          subConditionList: [],
          subRoleList: [{
            isAdd: true,
            shareMode: SystemConstants.SHARE_MODE_JOB.code,
            usdRatio: 0,
            nonUsdRatio: 0
          }]
        }],
        formSubtype: null
      },
      ruleConfigurationDialog: {
        visible: false
      },
      rules: [],
      node: {
        isAdd: false,
        shareMode: SystemConstants.SHARE_MODE_JOB.code, // 分润模式：job=整票、currency=币种
        usdRatio: 0, // 美金比例
        nonUsdRatio: 0 // 非美金比例
      },
      preCriteriaOptions: [],
      oldSelect: null,
      activeTab: 'activity',
      showDetail: false,
      documentManage: new DocumentManage(),
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: event => {
          this.selectRow = event.data
        }
      },
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), field: 'serialNumber', width: 25, sortable: false },
        { headerName: this.$t('CargoMsg.Cargo_RuleName'), field: 'name', colId: 'name', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'), field: 'branchIds', colId: 'branchIds', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'enabled', colId: 'enabled', flex: 1,
          cellRenderer: params => {
            const changeEnabled = this.documentManage.getPath('toChangeEnabled')
            const id = "'" + params.data.uuid + "'"
            const name = params.value ? this.$t('CargoMsg.Cargo_Deactivate') : this.$t('CargoMsg.Cargo_Enable')
            const state = !params.value
            if (params.value) {
              return `<button><div onclick="${changeEnabled}(${id}, ${state})" style="display: inline-block;color:rgba(217, 3, 29);margin-right: 5px;cursor: pointer">${name}</div></button>`
            }
            return `<button><div onclick="${changeEnabled}(${id}, ${state})" style="display: inline-block;color:rgba(146, 199, 63);margin-right: 5px;cursor: pointer">${name}</div></button>`
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', colId: 'remark', flex: 1 },
        { headerName: this.$t('CargoMsg.Cargo_UpdatePerson'), field: 'modifiedBy',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.UpdateTime'), field: 'dateModified',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.DateOfCreation2'), field: 'dateCreated',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      filter: {
        total: 0,
        pageNum: 0,
        pageSize: 20,
        names: [],
        branchIds: [],
        enabled: null
      },
      rowData: [],
      selectRow: null,
      WorkflowConstants: WorkflowConstants
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    showNonUsdRatioInput() {
      return this.node.shareMode !== SystemConstants.SHARE_MODE_JOB.code
    }
  },
  watch: {
    email(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!newVal) {
          this.form.notifyUserId = []
        }
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toChangeEnabled', function(id, state) {
      context.toChangeEnabled(id, state)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  async created() {
    await this.init()
    this.toQuery()
  },
  methods: {
    async init() {
      queryConditions({ ruleType: 'profitShare' }).then(res => {
        this.rules = res.data
      })
    },
    toQuery() {
      const params = this.filter
      //
      this.loading = getLoading()
      query(params).then(res => {
        this.rowData = res.data.list
        ColumnUtils.addSerialNumber(this.rowData)
        params.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    toCreate() {
      this.form = {
        name: '',
        branchIds: [],
        remark: '',
        enabled: true,
        ruleType: 'profitShare',
        multiSub: true,
        subList: [{
          priority: 1,
          ruleMode: WorkflowConstants.RULE_CONDITIONS_ALL.code,
          multiRole: false,
          subConditionList: [],
          subRoleList: [{
            isAdd: true,
            shareMode: SystemConstants.SHARE_MODE_JOB.code,
            usdRatio: 0,
            nonUsdRatio: 0
          }]
        }]
      }
      this.node = {
        isAdd: false,
        shareMode: SystemConstants.SHARE_MODE_JOB.code,
        usdRatio: 0,
        nonUsdRatio: 0
      }
      this.activeTab = 'activity'
      this.showDetail = true
    },
    async toEdit() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      await this.showProcessDetail(this.selectRow)
    },
    toCopy() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('Message.SelectTheData'))
        return
      }
      this.loading = getLoading()
      copy({ uuid: this.selectRow.uuid }).then(res => {
        this.$message.success(this.$t('SeaExport.CopySuccess'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 启用禁用
    toChangeEnabled(id, state) {
      this.loading = getLoading()
      setEnabled({ uuids: [id], enabled: state }).then(res => {
        const array = this.rowData.filter(item => item.uuid === id)
        array[0].enabled = state
        this.gridOptions.api.refreshCells({ force: true })
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存
    async onSave() {
      const data = deepClone(this.form)
      // 去掉新增的节点
      for (const workflow of data.subList) {
        if (workflow.subRoleList && workflow.subRoleList.length > 0) {
          workflow.subRoleList = workflow.subRoleList.filter(item => !item.isAdd)
        }
      }
      // 数据校验
      if (this.check(data)) {
        return
      }
      if (data.uuid && !lodash.isEqual(this.oldSelect, data)) {
        const flag = await this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureModifyRuleConfigTips'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning',
          closeOnClickModal: false
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      // 分公司IDs
      if (this.form.branchIds) {
        let text = ''
        for (const data of this.form.branchIds) {
          if (text.length !== 0) {
            text = text + ','
          }
          text = text + data
        }
        data.branchIds = text
      } else {
        data.branchIds = ''
      }

      this.loading = getLoading()
      save(data).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.onCancel()
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    onCancel() {
      this.selectRow = null
      this.showDetail = false
    },
    onConfiguration(workflowIndex) {
      this.chooseWorkflowIndexRule = workflowIndex
      this.ruleConfigurationDialog.visible = true
    },
    async onRowDoubleClicked(event) {
      const data = event.data
      await this.showProcessDetail(data)
    },
    async showProcessDetail(data) {
      this.activeTab = 'activity'
      this.choosePriority = null
      this.chooseIndex = null
      this.node = {
        isAdd: false,
        shareMode: SystemConstants.SHARE_MODE_JOB.code,
        usdRatio: 0,
        nonUsdRatio: 0
      }
      this.loading = getLoading()
      detail({ uuid: data.uuid }).then(res => {
        const data = res.data
        this.oldSelect = deepClone(data)
        data.notifyUserId = data.notifyUserId ? commonUtil.splitToNumberArray(data.notifyUserId, ',') : []
        data.branchIds = data.branchIds ? commonUtil.splitToNumberArray(data.branchIds, ',') : []
        // 添加新增节点数据
        data.subList.forEach(workflow => {
          if (!workflow.subRoleList) {
            workflow.subRoleList = []
          }
          workflow.subRoleList.push({
            isAdd: true,
            shareMode: SystemConstants.SHARE_MODE_JOB.code,
            usdRatio: 0,
            nonUsdRatio: 0
          })
        })
        this.form = data
        this.showDetail = true
      }).finally(() => {
        this.loading.close()
      })
    },
    addNode(workflowIndex, priority) {
      const subRoleList = this.form.subList[workflowIndex].subRoleList
      const length = subRoleList.length
      const newNode = { isAdd: false,
        shareMode: SystemConstants.SHARE_MODE_JOB.code,
        usdRatio: 0,
        nonUsdRatio: 0
      }
      subRoleList.splice(length - 1, 0, newNode)
      this.chooseNode(newNode, priority, length - 1)
    },
    removeNode(workflowIndex, index) {
      // 删除节点
      if (this.choosePriority === this.form.subList[workflowIndex].priority &&
        this.chooseIndex === index) {
        this.choosePriority = null
        this.chooseIndex = null
        this.node = {
          isAdd: false,
          shareMode: SystemConstants.SHARE_MODE_JOB.code,
          usdRatio: 0,
          nonUsdRatio: 0
        }
      }
      this.form.subList[workflowIndex].subRoleList.splice(index, 1)
    },
    chooseNode(node, priority, index) {
      if (node.isAdd) {
        return
      }
      this.choosePriority = priority
      this.chooseIndex = index
      // 选中节点
      this.node = node
      this.activeTab = 'node'
    },
    showShareMode(node) {
      return this.$t('CargoMsg.Cargo_ShareModeTip') + (node.shareMode !== SystemConstants.SHARE_MODE_JOB.code ? this.$t('CargoMsg.Cargo_Currency') : this.$t('CargoMsg.Cargo_ShareModeJobTip'))
    },
    showUsdRatio(node) {
      return this.$t('CargoMsg.Cargo_ShareRatio') + (node.shareMode !== SystemConstants.SHARE_MODE_JOB.code ? 'USD' : '') + node.usdRatio + '%'
    },
    showNonUsdRatio(node) {
      return node.shareMode !== SystemConstants.SHARE_MODE_JOB.code ? (this.$t('CargoMsg.Cargo_ShareRatio') + this.$t('CargoMsg.Cargo_Other') + node.nonUsdRatio + '%') : ''
    },
    check(data) {
      if (!data.name || !data.name.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_RuleName'))
        return true
      }
      if (!data.branchIds || data.branchIds.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSalesBranch'))
        return true
      }
      data.name = data.name.trim()
      // 校验分支
      if (!data.subList || data.subList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RuleConfigSubCountNotNull'))
        return true
      }
      for (const workflow of data.subList) {
        const subRoleList = workflow.subRoleList
        // 校验节点
        if (!subRoleList || subRoleList.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintain') + this.$t('CargoMsg.Cargo_RuleRole'))
          return true
        }
        // 校验规则 请设置流程触发条件。
        if (!(WorkflowConstants.RULE_CONDITIONS_NONE.code === workflow.ruleMode)) {
          if (!workflow.subConditionList || workflow.subConditionList.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SetUpConfigSubTriggerCondition'))
            return true
          }
          for (const workflowRule of workflow.subConditionList) {
            const tempRules = this.rules.filter(rule => rule.column === workflowRule.column)
            if (!tempRules || tempRules.length === 0) {
              this.$message.warning(this.$t('CargoMsg.Cargo_ConfigSubRuleError'))
              return true
            }
          }
        }
        for (const node of subRoleList) {
          if (StrUtils.isEmpty(node.usdRatio)) {
            node.usdRatio = 0
          }
          if (StrUtils.isEmpty(node.nonUsdRatio)) {
            node.nonUsdRatio = 0
          }
          // 整票
          if (node.shareMode === SystemConstants.SHARE_MODE_JOB.code) {
            node.nonUsdRatio = 0
          }
        }
      }
      return false
    },
    toEnd() {
      this.choosePriority = null
      this.chooseIndex = null
      // 去掉选中节点
      this.node = {
        isAdd: false,
        shareMode: SystemConstants.SHARE_MODE_JOB.code,
        usdRatio: 0,
        nonUsdRatio: 0
      }
    },
    sort({ to, form, item, clone, oldIndex, newIndex }) {
      //
    },
    async addBranchProcess() {
      this.form.subList = [...this.form.subList,
        {
          priority: !this.form.subList || this.form.subList.length === 0 ? 1 : Math.max(...this.form.subList.map(({ priority }) => priority)) + 1,
          ruleMode: WorkflowConstants.RULE_CONDITIONS_ALL.code,
          multiRole: false,
          subConditionList: [],
          subRoleList: [{
            isAdd: true,
            shareMode: SystemConstants.SHARE_MODE_JOB.code,
            usdRatio: 0,
            nonUsdRatio: 0
          }]
        }]
    },
    removeBranch(workflowIndex) {
      // 删除分支流
      if (this.choosePriority === this.form.subList[workflowIndex].priority) {
        this.choosePriority = null
        this.chooseIndex = null
        this.node = {
          isAdd: false,
          shareMode: SystemConstants.SHARE_MODE_JOB.code,
          usdRatio: 0,
          nonUsdRatio: 0
        }
      }
      this.form.subList.splice(workflowIndex, 1)
    },
    getTriggerConditionsLabel(ruleMode) {
      const state = SystemConstants.getCommonState(ruleMode, WorkflowConstants.RULE_CONDITIONS)
      if (!state) return ''
      return this.isZh ? state.chineseName : state.englishName
    },
    handleTabClick() {
      if (this.activeTab === 'node') {
        this.$nextTick(() => {
          if (this.form.subList && this.form.subList.length > 0) {
            const item = this.form.subList[0]
            if (item && item.subRoleList && item.subRoleList.length > 0) {
              this.chooseNode(item.subRoleList[0], item.priority, 0)
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.profit-share-config {
  .tabs-container{
    height: 100%;
  }
  .el-tabs__item{
    width: 130px;
  }
  .el-tabs__content{
    width: 270px;
  }
  textarea{
    max-height: 80px;
    min-height: 80px !important;
  }
  /* 设置箭头容器样式 */
  .arrow-container {
    width: 80px; /* 宽度减半 */
    height: 10px; /* 高度减半 */
    top: 50%;
    bottom: 50%;
    position: relative;
  }

  /* 设置箭头线条样式 */
  .arrow-line {
    width: 90px;
    height: 1px; /* 高度减半 */
    background-color: #909399;
    margin-top: auto;
    margin-bottom: auto;
    position: absolute;
    top:0;
    bottom:0;
  }

  /* 设置箭头尖端样式 */
  .arrow-head {
    width: 0;
    height: 0;
    border-top: 5px solid transparent; /* 上边框宽度减半 */
    border-bottom: 5px solid transparent; /* 下边框宽度减半 */
    border-left: 10px solid #909399; /* 左边框宽度减半 */
    position: absolute;
    right:-1px;
  }

  /* 设置上半部分小三角形样式 */
  .arrow-head::before {
    content:"";
    width :0 ;
    height :0 ;
    border-top:none;
    border-left:none;
    border-right:none;
    border-bottom-width :1px ;/* 下 边 框 宽 度 减 半*/
    position:absolute;/* 绝 对 定位*/
    left:-9.5 px ;/* 左 移9.5像素*/
    top:-1 px ;/* 上 移1像素*/
  }

  /* 设置下半部分小三角形样式 */
  .arrow-head::after {
    content:"";
    width :0 ;
    height :0 ;
    border-bottom:none;/* 去 掉下 边 框*/
    border-left:none;/* 去 掉左 边 框*/
    border-right:none;/* 去 掉右 边 框*/
    border-top-width :1px ;/* 上 边 框 宽 度 减 半*/
    position:absolute;/* 绝 对 定位*/
    left:-9.5 px ;/* 左 移9.5像素*/
    bottom :-1 px ;/* 下 移1像素*/
  }

  .record-card{
    width: 180px; height: 95px;
    border-color: rgba(240, 240, 240, 1);
    border-style: solid;
    border-width: 3px;
    border-radius: 5px;
  }
  .is-active{
    background-color: #1f75d5b0 !important;
  }
  .card-content{
    margin: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 3;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /*! autoprefixer: on */
    text-align: center;
  }
  .node-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-icon-delete{
    margin-left:auto;
    cursor: pointer;
  }
  .no-click{
    pointer-events: none;
  }

  .no-drag {
    user-select: none;
    cursor: default;
  }
  .drag-handle {
    user-select: none;
    cursor: move;
  }
  .col {
    width: 100%;
    flex: 1;
    padding: 10px;
    border: solid 1px #eee;
    border-radius: 5px;
    float: left;
  }
  .item {
    border: solid 1px #eee;
    background-color: white;
  }
  .item:hover {
    background-color: #fdfdfd;
    cursor: move;
  }
  .item + .item {
    border-top: none;
    margin-top: 6px;
  }
}
</style>
